/**
 * MainTransportButtons Component
 * Main transport play/pause/stop buttons for center toolbar
 */

import React from 'react';
import { Button } from '../../ui/button';
import { SkipBack, Play, Pause, Square } from 'lucide-react';
import { ContextualTooltip } from '../../ContextualTooltip';

export const MainTransportButtons = ({
  isPlaying,
  currentTime,
  playAll,
  stopAll,
  seekTo,
  setCurrentTime,
  showCollaboration,
  formatTime,
}) => {
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => seekTo(0)}
        className="text-zinc-400 hover:text-white p-1 md:p-2"
        data-testid="transport-start"
      >
        <SkipBack className="w-4 h-4 md:w-5 md:h-5" />
      </Button>
      
      {isPlaying ? (
        <Button
          onClick={stopAll}
          className="bg-amber-500 hover:bg-amber-600 rounded-full w-10 h-10 md:w-12 md:h-12 shadow-lg shadow-amber-500/30"
          data-testid="transport-pause"
        >
          <Pause className="w-5 h-5 md:w-6 md:h-6" />
        </Button>
      ) : (
        <ContextualTooltip id="transport-play" position="bottom">
          <Button
            onClick={playAll}
            className="bg-emerald-500 hover:bg-emerald-600 rounded-full w-10 h-10 md:w-12 md:h-12 shadow-lg shadow-emerald-500/30"
            data-testid="transport-play"
          >
            <Play className="w-5 h-5 md:w-6 md:h-6 ml-0.5" />
          </Button>
        </ContextualTooltip>
      )}
      
      <ContextualTooltip id="transport-stop" position="bottom">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => { 
            // Send stop with position 0
            if (showCollaboration && window.__collabSendTransport) {
              window.__collabSendTransport('stop', 0);
            }
            stopAll(false); // Don't broadcast again
            setCurrentTime(0); 
          }}
          className="text-zinc-400 hover:text-white p-1 md:p-2"
          data-testid="transport-stop"
        >
          <Square className="w-4 h-4 md:w-5 md:h-5" />
        </Button>
      </ContextualTooltip>
      
      {/* Time Display */}
      <div className="bg-zinc-800/80 px-2 md:px-4 py-1.5 md:py-2 rounded-lg font-mono text-sm md:text-lg min-w-[100px] md:min-w-[140px] text-center">
        {formatTime(currentTime)}
      </div>
    </>
  );
};

export default MainTransportButtons;
